// ----------------------------------------------------------------------
// <copyright file="Izenda.CategoryAccessibility.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');

  const { filter, isEmpty, some, map, forEach, flow, pick, invokeMap, find } = require('lodash/fp');

  var Category = function(data, hideNumber) {
    var props = {
      id: null,
      displayKey: function() {
        return String.format('{0}-{1}-{2}', this.id, this.tenantId, !!this.isGlobal /* true|false*/);
      },
      name: null,
      visible: false,
      canVisible: true,
      savable: false,
      canSavable: true,
      subCategories: [],
      parentId: null,
      tenantId: null,
      isGlobal: false,
      showNumChildren: !hideNumber,

      isSubCategory: function() {
        return isEmpty(this.subCategories.slice());
      },
      showInAvailableTree: function() {
        return !this.visible || some('showInAvailableTree', this.subCategories);
      },
      showInSavableTree: function() {
        return this.savable || some('showInSavableTree', this.subCategories);
      },
      showInVisibleTree: function() {
        return (this.visible && !this.savable) || some('showInVisibleTree', this.subCategories);
      }
    };

    m.extendObservable(this, props);

    data && this.readBasicInfo(data);
  };

  /**
   * read category information
   */
  Category.prototype.readBasicInfo = m.action(function(data) {
    this.id = data.id;
    this.name = data.name;
    this.tenantId = data.tenantId;
    this.subCategories = map(function(subCategogy) {
      return new Category(subCategogy);
    }, data.subCategories);
    this.parentId = data.parentId;
    this.isGlobal = data.isGlobal;
  });

  /**
   * change Cateogry visible property
   */
  Category.prototype.toggleVisible = m.action(function(newValue) {
    this.visible = this.canVisible && newValue;
  });

  /**
   * change category savable property
   */
  Category.prototype.toggleSavable = m.action(function(newValue) {
    this.savable = !this.isGlobal && newValue;
  });

  /**
   * Build data saving for item category/ sub-category
   * @return {object}  category
   */
  Category.prototype.prepareDataForSave = m.action(function(newValue) {
    return {
      id: this.id,
      savable: this.showInSavableTree,
      tenantId: this.tenantId,
      name: this.name,
      isGlobal: this.isGlobal,
      subCategories: flow(
        filter(function(item) {
          return item.showInVisibleTree || item.showInSavableTree;
        }),
        map(function(note) {
          return {
            id: note.id,
            savable: note.savable,
            tenantId: note.tenantId,
            name: note.name,
            subCategories: flow(filter('visible'), map(pick(['id', 'savable', 'tenantId', 'name'])))(note.subCategories)
          };
        })
      )(this.subCategories)
    };
  });

  var CategoryAccessibility = function(isTenantSetup) {
    var props = {
      categories: []
    };
    this.isTenantSetup = !!isTenantSetup;

    m.extendObservable(this, props);
  };

  CategoryAccessibility.prototype.reset = function() {
    this.categories = [];
  };

  /**
   * build categoris list
   * @method populateData
   * @param  {[type]}     data [description]\
   */
  CategoryAccessibility.prototype.populateData = m.action(function(data) {
    this.categories = map(function(category) {
      return new Category(category, true);
    }, data);
  });

  /**
   * Build visible and savable item for saving
   * @return {array} list visible/ savable categories/ sub-categories
   */
  CategoryAccessibility.prototype.prepareDataForSave = function() {
    return flow(
      filter(function(item) {
        return item.showInVisibleTree || item.showInSavableTree;
      }),
      invokeMap('prepareDataForSave')
    )(this.categories);
  };

  /**
   * read permission model
   */
  CategoryAccessibility.prototype.readCategoryAccessibility = m.action(function(data) {
    var recursiveToggle = function(data, source) {
      forEach(function(item) {
        var note = find({ id: item.id, tenantId: item.tenantId }, source);
        if (note) {
          note.toggleSavable(item.savable);
          note.toggleVisible(true);
        }
        item && note && recursiveToggle(item.subCategories, note.subCategories);
      }, data);
    };
    recursiveToggle(data, this.categories);
  });

  module.exports = CategoryAccessibility;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.CategoryAccessibility.js